import { Product, WithContext } from 'schema-dts';
import { Product as ProductType } from 'src/types';

export function productSchema(
  product: ProductType,
  description: string
): WithContext<Product> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description,
  };
}
